<template>
    <div class="p-4  text-black">
        <div class="w-100">
            <div id="recaptcha-container"></div>
        </div>
        <img @click="$router.push('/delivery/menulists')" width="40px" src="/img/close.png"
            style="position: fixed;left: 0;top: 0;margin: 1cap;z-index: 1090;">
        <AppPushNotification ref="notification" :title="notificationModel.title" :text="notificationModel.text"
            :color="notificationModel.color" />
        <div class="row ">
            <div class="col-md-6 col-sm-12 order-md-2 order-1">
                <!-- Show this only on small screens (sm and below) -->
                <img src="/img/loginCover.webp" class="img-bg d-block d-md-none" />
                <!-- Show this only on medium screens and up -->
                <img class="login-cover-img d-none d-md-block" width="100%" src="/img/loginCover.webp" />
            </div>
            <div class="col-md-6 col-sm-12 order-md-1 order-2 login-conteainer">
                <template v-if="stage == 0" name="login-section">
                    <h3>{{ $t('welcomeBack') }}</h3>
                    <span class="text-description">{{ $t('welcomeBackDespt') }}</span>
                    <form class="mt-4">
                        <div class="form-group">
                            <label for="exampleInputEmail1">{{ $t('email') }}</label>
                            <input v-model="loginForm.email" type="email" class="form-control form-round-box"
                                id="exampleInputEmail1" :placeholder="$t('enterYourEmail')" />
                        </div>
                        <div class="form-group position-relative">
                            <label for="exampleInputPassword1">{{ $t('password') }}</label>
                            <input v-model="loginForm.password" :type="showPassword ? 'text' : 'password'"
                                class="form-control form-round-box" id="exampleInputPassword1"
                                :placeholder="$t('enterPassword')" />
                            <i @click="showPassword = !showPassword"
                                :class="showPassword ? ' fi fi-rr-eye show-password-btn ' : 'fi fi-rr-eye-crossed show-password-btn '"></i>
                        </div>
                        <span id="emailHelp" class="form-text text-right text-muted" @click="showForgotPassword">
                            {{ $t('forgetPassword') }}?
                        </span>
                        <CButton block class="btn-color-theme mt-3" @click.prevent="handleEmailLogin()">{{ $t('login')}}</CButton>
                    </form>
                    <div class="login-divider text-muted my-4">
                        <span>{{ $t('orLoginWith') }}</span>
                    </div>
                    <div class="d-flex justify-content-center">
                        <CButton v-for="(service, index) in authenServices" :key="'sevice-' + index"
                            class="authen-service-btn" @click="service.click && service.click()">
                            <img :src="service.img" width="24px" />
                        </CButton>
                    </div>
                    <h6 class="text-center mt-5 mb-0">
                        {{ $t('dontHaveAccount') }}
                        <span style="color: var(--bg-color-theme); cursor: pointer;" @click="stage = 1">{{
                            $t('register') }}</span>
                    </h6>
                </template>
                <template v-if="stage == 1" name="register-section">
                    <h3>{{ $t('createAccount') }}</h3>
                    <span class="text-description">{{ $t('createAccountDespt') }}</span>
                    <form class="mt-4">
                        <div class="form-group">
                            <label>{{ $t('fullName') }}</label>
                            <input v-model="registerForm.name" type="text" class="form-control form-round-box"
                                :placeholder="$t('fullNameDespt')" />
                        </div>
                        <div class="form-group">
                            <label>{{ $t('email') }}</label>
                            <input v-model="registerForm.email" type="email" class="form-control form-round-box"
                                :placeholder="$t('emailDespt')" />
                        </div>
                        <div class="form-group">
                            <label>{{ $t('tel') }}</label>
                            <input v-model="registerForm.phone" type="tel" class="form-control form-round-box"
                                :placeholder="$t('enterPhone')" />
                            <small class="text-grey">*{{ $t('example') }} 0996667777</small>
                        </div>
                        <div class="form-group position-relative">
                            <label>{{ $t('password') }}</label>
                            <input v-model="registerForm.password" :type="showPassword ? 'text' : 'password'"
                                class="form-control form-round-box" :placeholder="$t('createPassword')" />
                            <i @click="showPassword = !showPassword"
                                :class="showPassword ? ' fi fi-rr-eye show-password-btn ' : 'fi fi-rr-eye-crossed show-password-btn '"></i>
                            <small class="text-grey">*{{ $t('passwordSet') }} </small>
                        </div>
                        <div class="form-group position-relative">
                            <label>{{ $t('confirmPassword') }}</label>
                            <input :type="showPassword ? 'text' : 'password'" class="form-control form-round-box"
                                :placeholder="$t('confirmPassword')" v-model="confirmPassword" />
                        </div>

                        <CButton block class="btn-color-theme mt-3" @click.prevent="handleRegister">{{ $t('register') }}
                        </CButton>
                    </form>
                    <h6 class="text-center mt-5 mb-0">
                        {{ $t('alreadyHaveAccount') }}?
                        <span style="color: var(--bg-color-theme); cursor: pointer;" @click="stage = 0">{{ $t('login')
                            }}</span>
                    </h6>
                </template>
                <template v-if="stage == 2">
                    <h3>{{ $t('verifyEmail') }}</h3>
                    <span class="text-description"> {{ $t('enterOTPSentTo') }}<br>
                        {{ $t('email') }} : {{ registerForm.email }}<br>
                        {{ $t('phoneNumber') }} : {{ registerForm.phone
                        }} </span>

                    <form class="mt-4">
                        <div class="form-group">
                            <label>{{ $t('emailOTP') }}</label>
                            <input v-model="emailOtp" type="text" maxlength="6" class="form-control form-round-box"
                                :placeholder="$t('emailOTPDesp')" />
                        </div>
                        <div class="form-group">
                            <label>{{ $t('phoneOTP') }}</label>
                            <input v-model="phoneOtp" type="text" maxlength="6" class="form-control form-round-box"
                                :placeholder="$t('phoneOTPDesp')" />
                        </div>
                        <CButton block class="btn-color-theme mt-3" @click.prevent="handleVerifyOTP">{{ $t('verifyOTP')
                            }}
                        </CButton>
                        <h6 style="text-decoration: underline;" class="mt-4 mb-0 w-100 text-center" @click="stage = 0">
                            {{ $t('cancel') }}</h6>
                    </form>
                    <h6 class="text-description mt-4" v-html="$t('checkSpamBox')" />
                </template>
                <template v-if="stage == 3">
                    <h3>{{ $t('resetPassword') }}</h3>
                    <span class="text-description">{{ $t('weWillSentOTPEmail') }}</span>
                    <form class="mt-4">
                        <div class="form-group">
                            <label>{{ $t('email') }}</label>
                            <input v-model="forgotForm.email" type="email" class="form-control form-round-box"
                                :placeholder="$t('enterYourEmail')" />
                        </div>

                        <div v-if="otpRequested">
                            <div class="form-group">
                                <label>OTP</label>
                                <input v-model="forgotForm.otp" type="text" maxlength="6"
                                    class="form-control form-round-box" :placeholder="$t('enterSixOTP')" />
                            </div>
                            <div class="form-group">
                                <label>{{ $t('newPassword') }}</label>
                                <input v-model="forgotForm.newPassword" type="password"
                                    class="form-control form-round-box" :placeholder="$t('createPassword')" />
                                <small class="text-grey">*{{ $t('passwordSet') }} </small>
                            </div>
                            <div class="form-group">
                                <label>{{ $t('confirmNewPassword') }}</label>
                                <input v-model="forgotForm.confirmPassword" type="password"
                                    class="form-control form-round-box" :placeholder="$t('confirmPassword')" />
                            </div>
                        </div>

                        <CButton block class="btn-color-theme mt-3"
                            @click.prevent="otpRequested ? handleResetPassword() : handleRequestOTP()"> {{ otpRequested
                                ? `${$t('resetPassword')}` : `${$t('sendOTP')}` }} </CButton>

                        <h6 style="text-decoration: underline;" class="mt-4 mb-0 w-100 text-center"
                            @click="cancelForgotPassword">
                            {{ $t('cancel') }}</h6>
                    </form>
                    <h6 class="text-description mt-4" v-html="$t('checkSpamBox')" />
                </template>
                <template v-if="stage == 4">
                    <h3>{{ $t('addPhoneNumber') }}</h3>
                    <span class="text-description">{{ $t('addPhoneForRegister') }}</span>
                    <form class="mt-3">
                        <div class="form-group">
                            <label>{{ $t('phoneNumber') }}</label>
                            <input  v-model="phoneNumberForm.phone" type="text"
                                class="form-control form-round-box" :placeholder="$t('enterPhone')" />
                        </div>
                        <!-- OTP INPUT -->
                        <!-- <div v-if="phoneOTPRequested" class="form-group">
                            <label>OTP</label>
                            <input v-model="phoneNumberForm.otp" type="text" class="form-control form-round-box"
                                :placeholder="$t('enterSixOTP')" />
                        </div> -->

                        <!-- OTP -->
                        <!-- <CButton :disabled="loadingButton" v-if="!phoneOTPRequested" block class="btn-color-theme mt-3"
                            @click.prevent="requestPhoneOTP()">
                            <CSpinner v-if="loadingButton" size="sm" />
                            {{ $t('sendOTP') }}
                        </CButton>
                        <CButton :disabled="loadingButton" v-else block class="btn-color-theme mt-3"
                            @click.prevent="handleCompletePhone">
                            <CSpinner v-if="loadingButton" size="sm" />
                            {{ $t('confirm') }}
                        </CButton> -->
                        <CButton :disabled="loadingButton" block class="btn-color-theme mt-3"
                            @click.prevent="handleCompletePhone">
                            <CSpinner v-if="loadingButton" size="sm" />
                            {{ $t('confirm') }}
                        </CButton>
                        <h6 style="text-decoration: underline;" class="mt-4 mb-0 w-100 text-center"
                            @click="cancelForgotPassword">
                            {{ $t('cancel') }}</h6>
                    </form>
                </template>
            </div>
        </div>
        <div v-show="isverifying" class="waiting-redirect">
            <div class="lds-ripple">
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
</template>
<script>
import pos from '@/services/pos'
import poscrm from '@/services/poscrm'
import { CButton } from '@coreui/vue';
import liff from '@line/liff';
import '@/util/loader.css'
import AppPushNotification from '@/components/AppPushNotification.vue'
import {
    initializeFirebaseAuth,
    sendOtp as sendFirebaseOTP,
    verifyOtp as confirmFirebaseOTP,
    resetRecaptcha
} from '@/util/firebasePhoneAuth';
import firebaseServices from '@/firebaseInit';
import jwt from 'jsonwebtoken';


export default {
    components: {
        AppPushNotification,
    },
    data() {
        return {
            stage: 0, /* 
            0 = Login Page
            1 = Register Page
            2 = Verify OTP Page
            3 = Forgot Password Page
            4 = Phone Number Register
            */

            showPassword: false,
            confirmPassword: '',
            authenServices: [
                {
                    img: '/img/line.png',
                    click: () => this.handleLineLogin()
                },
                {
                    img: '/img/google.png',
                    click: () => this.handleGoogleLogin()
                },
                // { img: '/img/apple-logo.png' }
            ],
            isverifying: false,
            registerForm: {
                email: "",
                password: "",
                name: "",
                phone: "",
            },
            otpCode: '',
            loginForm: {
                email: '',
                password: ''
            },
            forgotForm: {
                email: '',
                otp: '',
                newPassword: '',
                confirmPassword: '',
            },
            otpRequested: false,
            phoneNumberForm: {
                profile: null,  // เก็บ profile ที่ได้จาก requirePhone
                phone: '',
                otp: null,
                ref: null,
            },
            notificationModel: {
                color: '',
                title: '',
                text: '',
            },
            // phoneOTPRequested: false, //OTP
            loadingButton: false,
            emailOtp: '',
            phoneOtp: '',
            confirmationResult: null,
        };
    },
    created() {
        this.autoLoginIfInLIFF()
        if (this.$route.query.requiredphone === 'true') {
           
            this.stage = 4; // Go to add phone stage
            const token = this.$route.query.token;
                if (token) {
                const decoded = jwt.decode(token);
                if (decoded?.profile) {
                    const profile = decoded.profile;

                    // กำหนด profile ให้กับ phoneNumberForm
                    this.phoneNumberForm.profile = {
                        objectId: profile.objectId || '',
                        id: profile.id || '',
                        name: profile.name || '',
                        email: profile.email || '',
                        avatar: profile.avatar || '',
                        provider: profile.provider || 'LINE',
                        unique: profile.unique || ''
                    };
                    // Save token and profile in storage
                    localStorage.setItem('token', token);
                    localStorage.setItem('refreshToken', this.$route.query.refreshToken || '');
                    localStorage.setItem('profileObjectId', profile.objectId);
                    localStorage.setItem('profile', JSON.stringify(profile));
                }
                }

                this.phoneNumberForm.ref = this.$route.query.ref || null;
        }

    },
    async mounted() {
    },
    methods: {
        isInLineApp() {
            const ua = navigator.userAgent.toLowerCase();
            return ua.includes('line');
        },
        async autoLoginIfInLIFF() {
            if (this.isInLineApp()) {
                this.isverifying = true
                try {
                    await liff.init({ liffId: process.env.VUE_APP_LIFF_ID_PROFILE_LOGIN });
                    if (liff.isLoggedIn()) {
                        // 🔥 Already logged in inside LIFF
                        const profile = await liff.getProfile();                        
                        const idToken = liff.getIDToken();
                        await this.sendTokenToBackend(idToken);
                    } else {
                        console.log('Not logged in in LIFF yet.');
                    }
                } catch (e) {
                    console.error('LIFF Auto Login Error:', e);
                }
            }

        },
        async handleLineLogin() {
            this.isverifying = true
            if (this.isInLineApp()) {
                try {
                    await liff.init({ liffId: process.env.VUE_APP_LIFF_ID_PROFILE_LOGIN });
                    if (!liff.isLoggedIn()) {
                        liff.login();
                    } else {
                        const profile = await liff.getProfile();
                        const idToken = liff.getIDToken();
                        await this.sendTokenToBackend(idToken);
                    }
                } catch (e) {
                    console.error('LIFF Login Error:', e);
                }
            } else {
                // 🌐 Outside LINE: OAuth
                const token = localStorage.getItem('token');
  
                const clientId = process.env.VUE_APP_LINE_LOGIN_CHANEL_ID;
                const redirectUri = encodeURIComponent(`${process.env.VUE_APP_API_URL}/api/v3.0/auth/line/callback`);
                const state = Math.random().toString(36).substr(2);
                const scope = 'profile openid email';
                const nonce = state;
                const lineUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&state=${state}&scope=${scope}&nonce=${nonce}`;
                window.location.href = lineUrl;
            }
        },
        async sendTokenToBackend(idToken) {
            try {
                const res = await poscrm({
                    url: `/api/v3.0/auth/liff`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: { idToken }
                });

                const result = res.data;
                if (result.data) {
                    const data = result.data;
                    if (data.requirePhone) {
                        // 📞 Require Phone: go to add phone page
                        this.phoneNumberForm.profile = data.profile;
                        this.stage = 4;
                        this.isverifying = false;
                    } else {
                        const { profileObjectId, token, refreshToken } = data;
                        localStorage.setItem('profileObjectId', profileObjectId);
                        localStorage.setItem('token', token);
                        localStorage.setItem('refreshToken', refreshToken);

                        const queryString = new URLSearchParams({
                            profileObjectId,
                            token,
                            refreshToken
                        }).toString();
                        
                        window.location.href = `/delivery/menulists?${queryString}`;
                    }

                }
            } catch (error) {
                console.error('Sending ID Token to backend failed:', error);
            }
        },
        async handleRegister() {
            initializeFirebaseAuth(firebaseServices.customerProfile.auth, 'recaptcha-container');
            if (!this.registerForm.name || !this.registerForm.email || !this.registerForm.phone || !this.registerForm.password) {
                this.showNotification(this.$t('validateInfomation'), '', 'danger');
                return;
            }

            if (!this.validateEmail(this.registerForm.email)) return;
            if (!this.validatePhone(this.registerForm.phone)) return;
            if (!this.validatePassword(this.registerForm.password)) return;

            if (this.registerForm.password !== this.confirmPassword) {
                this.showNotification(this.$t('passwordNotMatch'), '', 'danger');
                return;
            }

            try {
                this.isverifying = true;

                const res = await poscrm({
                    url: `/api/v3.0/auth/email/register`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                        email: this.registerForm.email,
                        password: this.registerForm.password,
                        name: this.registerForm.name,
                        phone: this.registerForm.phone
                    }
                });

                const result = res.data?.data || {};

                if (result.success) {
                    // ✅ Send phone OTP using Firebase after registration
                    const formattedPhone = '+66' + this.registerForm.phone.slice(1);
                    this.confirmationResult = await sendFirebaseOTP(formattedPhone);
                    this.showNotification(this.$t('verifyOTP'), '', 'success');
                    this.stage = 2;
                } else {
                    switch (res.data.error.code) {
                        case 4000:
                            this.showNotification(this.$t('validateInfomation'), '', 'danger');
                            break;
                        case 4001:
                            this.showNotification(this.$t('emailUsed'), '', 'danger');
                            break;
                        case 4002:
                            this.showNotification(this.$t('phoneUsed'), '', 'danger');
                            break;
                        default:
                            break;
                    }
                }

            } catch (error) {
                console.error('Register Error:', error);
                this.showNotification(this.$t('somethingWentWrong'), error.message, 'danger');
            } finally {
                this.isverifying = false;
            }
        },

        async handleVerifyOTP() {
            if (!this.emailOtp || this.emailOtp.length !== 6 || !this.phoneOtp || this.phoneOtp.length !== 6) {
                this.showNotification(this.$t('otpInvalid6'), '', 'danger');
                return;
            }

            if (!this.confirmationResult) {
                this.showNotification(this.$t('otpExpiredOrNotSent'), '', 'danger');
                return;
            }

            try {
                this.isverifying = true;

                // 🔐 Verify phone OTP with Firebase
                const userCredential = await confirmFirebaseOTP(this.confirmationResult, this.phoneOtp);
                const verifiedPhone = userCredential.user.phoneNumber;
                console.log('✅ Firebase Phone Verified:', verifiedPhone);

                // 📧 Then verify email OTP via your backend
                const res = await poscrm({
                    url: `/api/v3.0/auth/email/verify`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                        email: this.registerForm.email,
                        emailOtp: this.emailOtp
                    }
                });

                const result = res.data?.data || {};

                if (result.token && result.profileObjectId && result.refreshToken) {
                    this.showNotification(this.$t('emailVerified'), '', 'success');

                    localStorage.setItem('profileObjectId', result.profileObjectId);
                    localStorage.setItem('token', result.token);
                    localStorage.setItem('refreshToken', result.refreshToken);

                    const queryString = new URLSearchParams({
                        profileObjectId: result.profileObjectId,
                        token: result.token,
                        refreshToken: result.refreshToken
                    }).toString();

                    window.location.href = `/delivery/menulists?${queryString}`;
                } else {
                    this.showNotification(this.$t('otpInvalid6'), '', 'danger');
                }

            } catch (error) {
                console.error('OTP verification failed:', error);
                this.showNotification(this.$t('otpInvalid6'), '', 'danger');
            } finally {
                this.isverifying = false;
            }
        },

        async handleGoogleLogin() {
            this.isverifying = true;

            try {
                const clientId = process.env.VUE_APP_GOOGLE_CLIENT_ID; // 👈 Your Google OAuth Client ID

                const tokenClient = window.google.accounts.oauth2.initTokenClient({
                    client_id: clientId,
                    scope: 'openid email profile',
                    callback: async (response) => {
                        if (response.error) {
                            console.error('Google Login Error:', response);
                            this.isverifying = false;
                            return;
                        }
                        // Send access_token to your backend to verify/login
                        await this.sendGoogleTokenToBackend(response.access_token);
                    },
                });

                tokenClient.requestAccessToken();
            } catch (error) {
                console.error('Google Login Error:', error);
                this.isverifying = false;
            }
        },
        async sendGoogleTokenToBackend(accessToken) {
            try {
                const res = await poscrm({
                    url: `/api/v3.0/auth/google`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: { accessToken }
                });

                const result = res.data.data;
                if (result) {
                    if (result.requirePhone) {
                        // 📞 Require Phone: go to add phone page
                        this.phoneNumberForm.profile = result.profile || null
                        this.phoneNumberForm.ref = result.ref || null
                        this.stage = 4;
                        this.isverifying = false;
                    } else {
                        const { profileObjectId, token, refreshToken } = result;
                        localStorage.setItem('profileObjectId', profileObjectId);
                        localStorage.setItem('token', token);
                        localStorage.setItem('refreshToken', refreshToken);

                        const queryString = new URLSearchParams({
                            profileObjectId,
                            token,
                            refreshToken
                        }).toString();

                        window.location.href = `/delivery/menulists?${queryString}`;
                    }
                }
            } catch (error) {
                console.error('Sending Google token to backend failed:', error);
            } finally {
                this.isverifying = false;
            }
        },
        async handleEmailLogin() {
            if (!this.loginForm.email || !this.loginForm.password) {
                this.showNotification(this.$t('validateInfomation'), '', 'danger');
                return;
            }

            if (!this.validateEmail(this.loginForm.email)) return;

            try {
                this.isverifying = true;

                const res = await poscrm({
                    url: `/api/v3.0/auth/email/login`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                        email: this.loginForm.email,
                        password: this.loginForm.password
                    }
                });

                const result = res.data?.data || {};

                if (result.token && result.profileObjectId && result.refreshToken) {
                    localStorage.setItem('profileObjectId', result.profileObjectId);
                    localStorage.setItem('token', result.token);
                    localStorage.setItem('refreshToken', result.refreshToken);

                    const profileObjectId = result.profileObjectId
                    const token = result.token
                    const refreshToken = result.refreshToken

                    const queryString = new URLSearchParams({
                        profileObjectId,
                        token,
                        refreshToken
                    }).toString();
                    window.location.href = `/delivery/menulists?${queryString}`;
                } else {
                    this.showNotification(this.$t('emailOrPasswordInvalid'), '', 'danger');
                }

            } catch (error) {
                console.error('Login Error:', error);
            } finally {
                this.isverifying = false;
            }
        },
        showForgotPassword() {
            this.stage = 3;
        },

        cancelForgotPassword() {
            this.stage = 0;
            this.otpRequested = false;
            this.forgotForm = { email: '', otp: '', newPassword: '', confirmPassword: '' };
        },

        async handleRequestOTP() {
            if (!this.forgotForm.email) {
                this.showNotification(this.$t('pleaseEnterEmail'), '', 'danger');
                return;
            }

            if (!this.validateEmail(this.forgotForm.email)) return;

            try {
                this.isverifying = true;

                const res = await poscrm({
                    url: `/api/v3.0/auth/email/forgot/request`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: { email: this.forgotForm.email }
                });

                if (res.data?.error?.code === 0) {
                    this.showNotification(this.$t('otpSentToEmail'), '', 'success');
                    this.otpRequested = true;
                } else {
                    this.showNotification('Failed to send OTP', '', 'danger');
                }
            } catch (error) {
                console.error('Request OTP Error:', error);
            } finally {
                this.isverifying = false;
            }
        },

        async handleResetPassword() {
            if (!this.validatePassword(this.forgotForm.newPassword)) return;

            if (this.forgotForm.newPassword !== this.forgotForm.confirmPassword) {
                this.showNotification(this.$t('passwordNotMatch'), '', 'danger');
                return;
            }
            try {
                this.isverifying = true;

                const res = await poscrm({
                    url: `/api/v3.0/auth/email/forgot/confirm`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                        email: this.forgotForm.email,
                        otp: this.forgotForm.otp,
                        newPassword: this.forgotForm.newPassword
                    }
                });

                if (res.data?.error?.code === 0) {
                    this.showNotification(this.$t('resetPasswordCompleted'), '', 'success');
                    this.cancelForgotPassword();
                } else {
                    this.showNotification(this.$t('failResetPassword'), '', 'danger');
                }
            } catch (error) {
                console.error('Reset Password Error:', error);
            } finally {
                this.isverifying = false;
            }
        },
        async handleCompletePhone() {
            this.loadingButton = true;

            try {
                // ตรวจสอบภายใน try เพื่อให้ finally ทำงานเสมอ
                if (!this.phoneNumberForm.phone || !this.validatePhone(this.phoneNumberForm.phone)) {
                this.loadingButton = false;
                return;
            }

                const res = await poscrm({
                    url: `/api/v3.0/auth/savePhone`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                        phone: this.phoneNumberForm.phone,
                        profile: this.phoneNumberForm.profile,
                        ref: this.phoneNumberForm.ref,
                    }
                });

                const result = res.data?.data || {};
                if (result.token && result.profileObjectId && result.refreshToken) {
                    localStorage.setItem('profileObjectId', result.profileObjectId);
                    localStorage.setItem('token', result.token);
                    localStorage.setItem('refreshToken', result.refreshToken);

                    const queryString = new URLSearchParams({
                        profileObjectId: result.profileObjectId,
                        token: result.token,
                        refreshToken: result.refreshToken,
                    }).toString();

                    window.location.href = `/delivery/menulists?${queryString}`;
                } else {
                    this.showNotification(this.$t('completePhoneFail'), '', 'danger');
                }

            } catch (err) {
                console.error('❌ OTP verification failed:', err);
                this.showNotification(this.$t('validateOTP'), '', 'danger');
            } finally {
                this.loadingButton = false;
                this.isverifying = false;
            }
        },
        //Flow เก่า กรณี request OTP แล้วต้องกรอก OTP เพื่อยืนยันเบอร์โทรศัพท์
        // async handleCompletePhone() {
        //     this.loadingButton = true
        //     if (!this.phoneNumberForm.phone || !this.validatePhone(this.phoneNumberForm.phone)) return;
        //     try {
        //         this.isverifying = true;

        //         const res = await poscrm({
        //             url: `/api/v3.0/auth/completePhone`,
        //             method: 'POST',
        //             headers: { 'Content-Type': 'application/json' },
        //             data: {
        //                 otp: this.phoneNumberForm.otp,
        //                 ref: this.phoneNumberForm.ref,
        //             }
        //         });

        //         const result = res.data?.data || {};

        //         if (result.token && result.profileObjectId && result.refreshToken) {
        //             localStorage.setItem('profileObjectId', result.profileObjectId);
        //             localStorage.setItem('token', result.token);
        //             localStorage.setItem('refreshToken', result.refreshToken);

        //             const profileObjectId = result.profileObjectId
        //             const token = result.token
        //             const refreshToken = result.refreshToken

        //             const queryString = new URLSearchParams({
        //                 profileObjectId,
        //                 token,
        //                 refreshToken
        //             }).toString();

        //             window.location.href = `/delivery/menulists?${queryString}`;
        //         } else {
        //             const errorCode = res.data?.error?.code
        //             switch (errorCode) {
        //                 case 4001:
        //                 case 4002:
        //                     this.showNotification(this.$t('validateOTP'), '', 'danger');
        //                     break;
        //                 case 4003:
        //                     this.showNotification(this.$t('otpExpired'), '', 'danger');
        //                     break;
        //                 default:
        //                     this.showNotification(this.$t('completePhoneFail'), '', 'danger');
        //                     break;
        //             }

        //         }

        //     } catch (error) {
        //         console.error('Complete Phone Error:', error);
        //     } finally {
        //         this.isverifying = false;
        //         this.loadingButton = false
        //     }
        // },
        showNotification(title, text, color) {
            this.notificationModel = {
                color: color,
                title: title,
                text: text,
            }
            this.$refs.notification.pushNotification();
        },
        validatePassword(password) {
            const minLength = 6;
            const hasNumber = /\d/;
            const hasLetter = /[a-zA-Z]/;

            if (password.length < minLength) {
                this.showNotification(this.$t('inValidPass'), '', 'danger');
                return false;
            }

            if (!hasNumber.test(password) || !hasLetter.test(password)) {
                this.showNotification(this.$t('inValidPass'), '', 'danger');
                return false;
            }

            return true;
        },

        validateEmail(email) {
            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email)) {
                this.showNotification(this.$t('plaseEnterValidEmail'), '', 'danger');
                return false;
            }
            return true;
        },
        validatePhone(phone) {
            const phonePattern = /^(06|08|09)\d{8}$/;
            if (!phonePattern.test(phone)) {
                this.showNotification('', this.$t('invalidPhoneNumber'), 'danger');
                return false;
            }
            return true;
        },
        // OTP
        // async requestPhoneOTP() {
        //     this.loadingButton = true
        //     const res = await poscrm({
        //         url: `/api/v3.0/auth/requestotp`,
        //         method: 'POST',
        //         headers: { 'Content-Type': 'application/json' },
        //         data: {
        //             profile: this.phoneNumberForm.profile,
        //             phone: this.phoneNumberForm.phone,
        //             ref: this.$route.query.ref || this.phoneNumberForm.ref || null
        //         }
        //     });
        //     if (res.data?.error?.code == 0) {
        //         const ref = res.data?.data?.ref || null
        //         this.phoneOTPRequested = true
        //         this.phoneNumberForm.ref = ref
        //         console.log('Request Phone : ', res)
        //     } else {
        //         this.showNotification(this.$t('phoneUsed'), '', 'danger');
        //     }
        //     this.loadingButton = false
        // }

        //from main master
        async requestPhoneOTP() {
            this.loadingButton = true;

            if (!this.phoneNumberForm.phone || !this.validatePhone(this.phoneNumberForm.phone)) {
                this.loadingButton = false;
                return;
            }
            try {
                this.loadingButton = true
                // Send Phone Number to Save in DB
                const res = await poscrm({
                    url: `/api/v3.0/auth/requestotp`,
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    data: {
                        profile: this.phoneNumberForm.profile,
                        phone: this.phoneNumberForm.phone,
                        ref: this.$route.query.ref || this.phoneNumberForm.ref || null
                    }
                });
                if (res.data?.error?.code == 0) {
                    const ref = res.data?.data?.ref || null
                    const formattedPhone = '+66' + this.phoneNumberForm.phone.slice(1); // Convert Thai phone format
                    // Initialize Firebase Auth + reCAPTCHA (render once)
                    initializeFirebaseAuth(firebaseServices.customerProfile.auth, 'recaptcha-container');
                    // Send OTP via Firebase
                    this.confirmationResult = await sendFirebaseOTP(formattedPhone);
                    this.phoneOTPRequested = true;
                    this.showNotification(this.$t('otpSentToPhone'), '', 'success');

                    this.phoneOTPRequested = true
                    this.phoneNumberForm.ref = ref
                    console.log('Request Phone : ', res)
                } else {
                    this.showNotification(this.$t('phoneUsed'), '', 'danger');
                    this.loadingButton = false;
                    return
                }

            } catch (error) {
                console.error('Firebase OTP error:', error);
                this.showNotification(this.$t('failToSendOTP'), '', 'danger');
            } finally {
                this.loadingButton = false;
            }
        }

    }
};

</script>

<style scoped>
.login-cover-img {
    border-radius: 28px;
    /* border: 1px solid #eeeeee; */
    height: 100%;
    object-fit: cover;
    box-shadow: 0 1.6px 3.6px 0 rgb(0 0 0 / 13%), 0 0.3px 0.9px 0 rgb(0 0 0 / 11%);
}

.form-round-box {
    border-radius: 100px;
    font-size: 16px;
    padding: 4.5cap 3cap;
    background-color: #f5f5f5;
}

.show-password-btn {
    position: absolute;
    right: 1.0rem;
    top: 2.7rem;
    z-index: 2;
    font-size: 1.3rem;
    color: #777777;
}

.authen-service-btn {
    border-radius: 100px;
    border: 1px solid #eeeeee;
    padding: 2cap 6cap;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0cap 2cap;
    background-color: white;
}

.login-divider {
    display: flex;
    align-items: center;
    text-align: center;
    width: 100%;
    font-size: 0.9rem;
    color: #999;
}

.login-divider::before,
.login-divider::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #ccc;
}

.login-divider::before {
    margin-right: 1rem;
}

.login-divider::after {
    margin-left: 1rem;
}

.img-bg {
    height: 100vh;
    position: fixed;
    top: 0;
    left: -250px;
    filter: brightness(0.6);
}

.login-conteainer {
    background-color: white;
    padding: 8cap 5cap;
    border-radius: 18px;
    z-index: 1080;
}

.waiting-redirect {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: #000000aa;
    z-index: 1090;
}
</style>